import React, { Component } from "react";
import { Field } from "redux-form";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchDropdown } from "../../../actions/actionCreators";

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown
} from "../../common/form/FieldHelper";

class InventoryStatusDropdown extends Component {
  render() {
    const {
      name,
      form,
      searchFn,
      multiple,
      preload = true,
      included_status
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType="inventory_status"
          type="inventory_status"
          valueField="id"
          preload={preload}
          searchParams={{
            included_status
          }}
          component={
            multiple ? renderSearchMultipleDropdown : renderSearchDropDown
          }
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(InventoryStatusDropdown);
